<label class="data-label" *ngIf="inputLabel" [ngClass]="labelClass">{{inputLabel}}</label>

<input [type]="inputType" #inputElement [style]="inputClass" [placeholder]="inputPlaceholder"
  [ngClass]="fControl && fControl.invalid && fControl.touched ? 'is-invalid':''" *ngIf="fControl"
  [formControl]="fControl" [required]="isRequired" accept="{{acceptFormat}}" class="form-control" (blur)="sendData()"
  (click)="onClick($event)" autocomplete="off">

<div *ngIf="fControl && fControl.invalid && fControl.touched">
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''" *ngIf="fControl.errors.required"> Please
    enter {{inputLabel | lowercase}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''" *ngIf="fControl.errors.email"> Invalid
    email</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.pattern && patternValidationMsg"> {{patternValidationMsg}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.max && maxValueValidationMsg"> {{maxValueValidationMsg}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.min && minValueValidationMsg"> {{minValueValidationMsg}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.maxlength && maxLengthValidationMsg"> {{maxLengthValidationMsg}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.minlength && minLengthValidationMsg"> {{minLengthValidationMsg}}</div>
  <div [ngClass]="fControl && fControl.invalid ? 'invalid-feedback d-block':''"
    *ngIf="fControl.errors.CustomError && customErrorValidationMsg"> {{customErrorValidationMsg}}</div>
</div>